import cssUtil from 'gw-portals-util-js/CssUtil';

import BaseWizardCtrl from '../baseTransaction/BaseTransactionWizardCtrl';
import BaseWizardView from 'text!../baseTransaction/baseTransactionWizard.html';

import TransactionConfirmationCtrl from '../TransactionConfirmation/TransactionConfirmationCtrl';
import TransactionConfirmationView from 'text!../TransactionConfirmation/TransactionConfirmation.html';
import TransactionConfirmationStyles from '../TransactionConfirmation/TransactionConfirmation-hashed.scss';

export default function () {

    var parentState = 'root';

    return {
        baseTransactionWizard: {
            parent: parentState,
            url: '/baseTransactionWizard',
            controller: BaseWizardCtrl,
            template: BaseWizardView,
            resolve: {
                submissionViewModel: ['StateUtils', function (StateUtils) {
                    return function () {
                        return StateUtils.dataForState('baseTransactionWizard').model;
                    };
                }]
            },
            data: {
                trackingUrl: function trackingUrl(state, params, model) {
                    var suffix = model && model.baseData ? '/' + model.baseData.productCode : '';
                    return '/transaction-flow' + suffix;
                }
            }
        },

        policyTransactionConfirmation: {
            name: 'confirmation',
            url: '/policyTransactionConfirmation',
            parent: parentState,
            controller: TransactionConfirmationCtrl,
            template: cssUtil.hashTemplate(TransactionConfirmationView, TransactionConfirmationStyles),
            params: {
                transactionSummary: null
            },
            data: {
                trackingUrl: function trackingUrl(state, params) {
                    return '/policyTransactionConfirmation/' + params.transactionSummary.baseData.productCode;
                }
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/config/RouteConfig.js
// module id = 1851
// module chunks = 0